import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Badge, Form, FormGroup, Input } from 'reactstrap';
import classnames from 'classnames';
import { connect } from 'react-redux';
import './correspondent.scss';
import TableView from "./tableView/index";
import { COMPLETED, PENDING, DEFAULT_PAGE_SIZE } from './constant'
import { ENTER } from '../../constants'
import { searchTaskList } from './helper'
import { viewAllTasks } from './action';
import withAuth from '../../components/Services/WithAuth'
class MyTasksComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: PENDING,
            tableData: {
                taskViewResponses: [],
                numberOfPages: 1
            },
            search: "",
            loading: true
        };
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
                loading: true
            }, () => {
                const requestBody = {
                    status: this.state.activeTab,
                    pageNo: 0,
                    pageSize: DEFAULT_PAGE_SIZE,
                    sorted: []
                }
                this.props.getTaskList(requestBody);
            });
        }
    }
    onPressEnter = (e) => {
        if (e.key === ENTER) {
            e.preventDefault();
            if (this.state.search && this.state.tableData) {
                this.setState({
                    tableData: searchTaskList(this.state.search, this.state.tableData)
                })

            }

        }
    }

    componentDidMount() {
        const requestBody = {
            status: PENDING,
            pageNo: 0,
            pageSize: DEFAULT_PAGE_SIZE,
            sorted: []
        }
        this.props.getTaskList(requestBody)
    }

    componentDidUpdate(prevProps) {
        if (this.props.taskList !== prevProps.taskList) {
            this.setState({
                tableData: this.props.taskList,
                loading: false
            })
        }
    }

    onInputChange = (e) => {
        this.setState({
            search: e.target.value
        })
    }
    onCompletedFetchPage = (status, pageNo, pageSize, sorted) => {
        this.setState({
            loading: true
        });
        const requestBody = {
            status: status,
            pageNo: pageNo,
            pageSize: pageSize,
            sorted: sorted
        }
        this.props.getTaskList(requestBody);
    }
    onPendingFetchPage = (status, pageNo, pageSize, sorted) => {
        this.setState({
            loading: true
        });
        const requestBody = {
            status: status,
            pageNo: pageNo,
            pageSize: pageSize,
            sorted: sorted
        }
        this.props.getTaskList(requestBody);
    }
    render() {
        let totalPendingCases, totalCompletedCases;
        if (this.state.activeTab === PENDING) {
            totalPendingCases = <Badge>{this.state.tableData.taskViewResponses ? this.state.tableData.taskViewResponses.length : 0}</Badge>;
            totalCompletedCases = null;
        } else {
            totalPendingCases = null;
            totalCompletedCases = <Badge>{this.state.tableData.taskViewResponses ? this.state.tableData.taskViewResponses.length : 0}</Badge>
        }
        return (
            <Col className="correspondent">
                <Nav tabs>
                    <NavItem className="mr-1">
                        <NavLink
                            className={classnames({ active: this.state.activeTab === PENDING })}
                            onClick={() => { this.toggle(PENDING); }}>
                            New / Pending Cases &nbsp; {totalPendingCases}
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === COMPLETED })}
                            onClick={() => { this.toggle(COMPLETED); }}>
                            Completed Cases &nbsp;{totalCompletedCases}
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab} className="row no-gutters py-3">
                    <TabPane tabId={PENDING} className="w-100">
                        <Form className="form-search mb-3">
                            <FormGroup className="mb-0 input-search">
                                <i className="icon-search position-absolute"></i>
                                <Input type="search" name="search" id="search" placeholder="Search within my portfolio" onChange={this.onInputChange} onKeyPress={this.onPressEnter} />
                            </FormGroup>
                        </Form>
                        <Row>
                            <Col>
                                <TableView
                                    data={this.state.tableData}
                                    loading={this.state.loading}
                                    status={PENDING}
                                    onFetchPage={this.onPendingFetchPage} />
                            </Col>

                        </Row>

                    </TabPane>
                    <TabPane tabId={COMPLETED} className="w-100">
                        <Form className="form-search w-35 mb-3">
                            <FormGroup className="mb-0 input-search">
                                <i className="icon-search position-absolute"></i>
                                <Input type="search" name="search" id="search" placeholder="Search within my portfolio" onChange={this.onInputChange} onKeyPress={this.onPressEnter} />
                            </FormGroup>
                        </Form>
                        <Row>
                            <Col>
                                <TableView
                                    data={this.state.tableData}
                                    loading={this.state.loading}
                                    status={COMPLETED}
                                    onFetchPage={this.onPendingFetchPage} />
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    taskList: state.correspondentListData.taskData
})

const mapDispatchToProps = (dispatch) => ({
    getTaskList: (data) => { dispatch(viewAllTasks(data)) }

});
export default withAuth(connect(mapStateToProps, mapDispatchToProps)(MyTasksComponent));
